// © 2015-2021 WDNA - All Rights Reserved

import Alarms from './loaders/Alarms';
import Actions from './loaders/Actions';
import Notifications from './loaders/Notifications';

export const redirects: any[] = [
  {
    from: '/alarms',
    to: '/alarms/alarms',
  },
];

export const routes: any[] = [
  {
    component: Alarms,
    path: '/alarms/alarms',
  },
  {
    component: Actions,
    path: '/alarms/actions',
  },
  {
    component: Notifications,
    path: '/alarms/notifications',
  },
];
